/**
 * Startprofil einer Instanz, abgeleitet aus den Modulen. 'angebote' = Angebots-Workflow ohne
 * Rechnungen und Auftragsabwicklung (Paket Angebotserstellung): eigene Übersicht, eigene
 * Navigation. Wenn der Entwurf für das Standalone-Produkt kommt, ändern sich nur dieses Profil,
 * die Navigation (components/navigation/navItems.ts) und die Angebots-Übersicht.
 */
import { type InstanceModuleMap, isModuleEnabled } from './instanceModules';

export type WorkspaceProfile = 'voll' | 'angebote';

export function resolveWorkspaceProfile(modules: Partial<InstanceModuleMap> | null | undefined): WorkspaceProfile {
  if (!modules) return 'voll';
  const offers = isModuleEnabled(modules, 'angebote');
  const invoices = isModuleEnabled(modules, 'rechnungen');
  const orders = isModuleEnabled(modules, 'auftraege');
  return offers && !invoices && !orders ? 'angebote' : 'voll';
}

/** Startseite nach /i/:id und nach dem Login (heute für beide Profile die Übersicht). */
export function startPathForProfile(_profile: WorkspaceProfile): string {
  return '/dashboard';
}
